import { NotFound } from "./theme/NotFound";
import { useParams } from "react-router-dom";
import { Process } from "./contract/Process";
import { Modality } from "./contract/Modality";
import { RequirementDocs } from "./contract/RequirementDocs";
import { AdquisitionPlanCatalog } from "./contract/AdquisitionPlanCatalog";
import { MisPlanesContratar } from "./contract/MisPlanesContratar";
import { MisPlanesPreparador } from "./contract/MisPlanesPreparador";
import { PlanTable } from "./contract/PlanTable";
import { DashboardPlan } from "./contract/DashboardPlan";
import { InboxSupplier } from "./supplier/InboxSupplier";
import { FixedCost } from "./contract/budget/FixedCost";
import { Formatos } from "./bpm/config/Componentes/Formatos";
import { FactorMatrix } from "./bpm/config/Componentes/FactorMatrix";
import { InboxEmployeeSupplier } from "./contract/InboxSupplier/InboxEmployeeSupplier";
import { RegisterContract } from "./contract/etapa-contrato/contrac/RegisterContract";
import { MisPlanesEstructured } from './contract/MisPlanesEstructured';
import { Contracts } from "./contract/etapa-contrato/contrac/Contracts";
import { ImportContract } from "./contract/etapa-contrato/contrac/importdata/ImportContract";
import { MakeUBLInvoice } from "./contract/etapa-contrato/contrac/ublinvoice/MakeUBLInvoice";
import { DraftOrders } from "./contract/etapa-contrato/contrac/DraftOrders";
import { OrderByReview } from "./contract/etapa-contrato/contrac/OrderByReview";
import { AccountingUBLInvoice } from "./contract/etapa-contrato/contrac/ublinvoice/AccountingUBLInvoice";
import { ManageAdquisitionItem } from "./contract/etapa-contrato/contrac/ublinvoice/AdquisitionItemEditor/ManageAdquisitionItem";
import { RequestNeed } from "./contract/RequestNeed/RequestNeed";
import { DashBoardPlanNew } from "./contract/DashBoardPlanNew";
import { TaxEntityConsecutive } from "./contabilidad/TaxBill/TaxEntityConsecutive/TaxEntityConsecutive";
import { AdminProcess } from "./erp/cellEditor/PaymentHeader/AdminProcess";
import { UBLInvoiceSupplier } from "./contract/etapa-contrato/contrac/UBLInvoiceSupplier/UBLInvoiceSupplier";
import { FixedAssetLine } from "./contract/etapa-contrato/contrac/ublinvoice/FixedAssetLine/FixedAssetLine";
import { FixedAssetOrderConcept } from "./contract/etapa-contrato/contrac/ublinvoice/FixedAssetOrderConcept/FixedAssetOrderConcept";
import { FixedAssetItem } from "./contract/etapa-contrato/contrac/ublinvoice/FixedAssetItem/FixedAssetItem";
import { ProyeccionNomina } from "./contract/ProyeccionNomina";
import { DerechoTurno } from "./contract/etapa-contrato/contrac/DerechoTurno";
import { ProjectResume } from "./erp/AdquisitionProject/ProjectResume";
import { ConsultProyectByObligation } from "./contract/etapa-contrato/contrac/ConsultProyectByObligation/ConsultProyectByObligation";
import { NeedsRequest } from "./contract/NeedsRequest";
import { UBLItemInvoiceGenerate } from "./contract/etapa-contrato/contrac/ublinvoice/ManageAssets/UBLItemInvoiceGenerate";
import { FixedAssetGroups } from "./contract/etapa-contrato/contrac/ublinvoice/FixedAssetItem/FixedAssetGroups/FixedAssetGroups";
import { SecopContractInfo } from "./contract/SECOP/SecopContractInfo/SecopContractInfo";
import { SecopContractAdjudicated } from "./contract/SECOP/SecopContractAdjudicated/SecopContractAdjudicated";
import { SecopPortfolio } from "./contract/SECOP/SecopPortfolio/SecopPortfolio";
import { ImportRegistry } from "./comercioexterior/ImportRegistry/ImportRegistry";
import { CostAnalysis } from "./comercioexterior/ImportRegistry/CostAnalysis";
import { ProductInventory } from "./comercioexterior/ProductInventory/ProductInventory";
import { SignList } from "./comercioexterior/OptionComponents/SignList/SignList";
import { NationalizationPhoto } from "./comercioexterior/OptionComponents/NationalizationPhoto/NationalizationPhoto";
import { CostSettlement } from "./comercioexterior/CostSettlement/CostSettlement";
import { ImportDeclaration } from "./comercioexterior/ImportDeclaration/ImportDeclaration";
import { DeliveryCertificate } from "./comercioexterior/DeliveryCertificate/DeliveryCertificate";
import { DirectUnchargeDeliveryCertificate } from "./comercioexterior/DeliveryCertificate/DirectUnchargeDeliveryCertificate";
import { UBLAdminFee } from "./contract/etapa-contrato/contrac/UBLAdminFee/UBLAdminFee";
import { UBLDispatcherContingency } from "./contract/etapa-contrato/contrac/UBLDispatcherContingency/UBLDispatcherContingency";
import { UBLDiscrepancyResponse } from "./contract/etapa-contrato/contrac/UBLDiscrepancyResponse/UBLDiscrepancyResponse";
import { FixedAssetItemReportColumn } from "./contract/etapa-contrato/contrac/ublinvoice/FixedAssetItem/FixedAssetItemReportColumn";
import { SignListFormat } from "./comercioexterior/SignListFormat/SignListFormat";


export const RouterContract = (props: any) => {
  const { module, view }: any = useParams();

  const renderSwitch = (url: string) => {
    switch (url) {
      case "procesos":
        return <Process />;
      case "modality":
        return <Modality />;
      case "documentos-requeridos":
        return <RequirementDocs />;
      case "planes-adquisicion":
        return <AdquisitionPlanCatalog />;
      // case "mis-planes":
      //   return <MisPlanes />;
      case "mis-planes-estructuracion":
        return <MisPlanesEstructured />;
      case "mis-planes-por-contratar":
        return <MisPlanesContratar rol={1} />;
      case "mis-planes-por-contratar-preparador":
        return <MisPlanesContratar rol={2} />;
      case "gestion-compras":
        return <MisPlanesContratar rol={4} />;
      case "mis-planes-preparador":
        return <MisPlanesPreparador />;
      case "mesa-trabajo":
        return <PlanTable />;
      case "formatos":
        return <Formatos />;
      case "Matrizdefactores":
        return <FactorMatrix />;
      case "dashboard-plan-consulta":
        return <DashBoardPlanNew />;
      case "dashboard-plan":
        return <DashboardPlan />;
      case "aprobacion-proveedores":
        return <InboxSupplier area={2} />;
      case "costos-fijos":
        return <FixedCost />;
      case "bandeja-gestion-compras":
        return <InboxEmployeeSupplier />;
      case "registar-contrato":
        return <RegisterContract />;
      case "mis-contratos":
        return <Contracts />;
      case "masivos-compras-contratacion":
        return <ImportContract />;
      case "gestion-cuentas-facturacion":
        return <MakeUBLInvoice />;

      case "tipos-aiu":
        return <UBLAdminFee />;

      case "periodos-contingencia":
        return <UBLDispatcherContingency />;

      case "tipos-discrepancias-documentos":
        return <UBLDiscrepancyResponse />

      case "facturas-proveedores":
        return <UBLInvoiceSupplier />;
      case "consultar-proyecto-obligacion":
        return <ConsultProyectByObligation />;
      case "entrada-activos-fijos":
        return <UBLItemInvoiceGenerate />;
      case "ordenes-de-pago-borrador":
        return <DraftOrders />;

      case "ordenes-pago-gestion":
        return <OrderByReview />;
      case "parametros-activos":
        return <FixedAssetLine />;
      case "conceptos-cuentas-orden":
        return <FixedAssetOrderConcept />;
      case "historial-activos-fijos":
        return <FixedAssetItem />;

      case "configuracion-reporte-activos":
        return <FixedAssetItemReportColumn />;

      case "contabilizar-factura":
        return <AccountingUBLInvoice />;
      case "catalogo-proceso":
        return <AdminProcess />;
      case "nuevas-necesidades":
        return <ManageAdquisitionItem menuComponent filterState={30} />;

      case "contabilizar-factura-rembolso":
        return <AccountingUBLInvoice entry="Reimbursement" />;
      case "bandeja-solicitar-necesidades":
        return <RequestNeed />;
      case "bandeja-gestionar-necesidades":
        return <RequestNeed interfaceProp="manager" />;
      case "numeracion-autorizada":
        return <TaxEntityConsecutive />;
      case "proyeccion-nomina":
        return <ProyeccionNomina />;
      case "derecho-turno":
        return <DerechoTurno />;
      case "resumen-proyectos":
        return <ProjectResume />;
      case "solicitud-necesidades":
        return <NeedsRequest />;
      case "grupos-activos":
        return <FixedAssetGroups />;


      case "secop-contract":
        return <SecopContractInfo />;

      case "secop-adjudication":
        return <SecopContractAdjudicated />;

      case "secop-portfolios":
        return <SecopPortfolio />;
      case "registro-importacion":
        return <ImportRegistry />;
      case "firmas-registro":
        return <SignList />;
      case "plantillas-firmas":
        return <SignListFormat />;
      case "registro-fotos":
        return <NationalizationPhoto />;
      case "cost-study":
        return <CostAnalysis />;
      case "productos-inventarios":
        return <ProductInventory />;
      case "liquidacion-costos":
        return <CostSettlement />;
      case "declaracion-importacion":
        return <ImportDeclaration />;
      case "acta-entrega":
        return <DeliveryCertificate />;
      case "acta-entrega-descargue-directo":
        return <DirectUnchargeDeliveryCertificate />;

      default:
        return <NotFound />;
    }
  };

  return (
    <div className="" >
      {renderSwitch(view)}
    </div>
  );
};
